import { Route, Routes } from "react-router-dom";

import ChangePasswordPage from "pages/ChangePasswordPage";
import LoginPage from "pages/LoginPage";
import ResetPasswordPage from "pages/ResetPasswordPage";

const LoginRoutes = () => {
  return (
    <Routes>
      <Route
        key="/reset-password"
        path="/password-reset"
        element={<ResetPasswordPage />}
      />
      <Route
        key="/change-password"
        path="/password-reset/change-password/:uid/:token"
        element={<ChangePasswordPage />}
      />
      <Route key="/" path="*" element={<LoginPage />} />
    </Routes>
  );
};

export default LoginRoutes;
